import { configureStore } from '@reduxjs/toolkit';

import userReducer from './userSlice';
import commonReducer from './commonSlice';
import payReducer from './paySlice';
import orderReducer from './orderSlice';
import deviceReducer from './deviceSlice';

export default configureStore({
	reducer: {
		user: userReducer,
		pay: payReducer,
		common: commonReducer,
		order: orderReducer,
		device: deviceReducer
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: [
					'pay/setClientInstance',
					'pay/setCreditCards',
					'user/setAccountInformation',
					'user/setUserProfile',
					'user/setUser',
					'user/setShippingAddress',
					'order/setOrderDetails'
				],
				ignoredPaths: [
					'pay.clientInstance',
					'pay.creditCards',
					'user.account',
					'user.account.user',
					'user.shippingAddress',
					'order.orderDetails'
				]
			}
		})
});
